import { createApp } from 'vue';
import FormComponent from './components/FormComponent.vue';
import { i18nVue } from 'laravel-vue-i18n'

const app = createApp({
    components: {
        'form-component': FormComponent,
    },
}).use(i18nVue, {
    resolve: lang => import(`../lang/${lang}.json`),
});

app.mount('#app');